module.exports = __webpack_public_path__ + "static/img/logo.8a9d7b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 83